import type { HistoryTurn } from '../api/types';
import { useProgramConfig } from '../config/useProgramConfig';
import { useTranslation } from '../i18n';
import { segmentReply } from '../utils/glossary';
import { GlossaryTerm } from './GlossaryTerm';
import './ChatBubble.css';

interface Props {
  turn: HistoryTurn;
  /** Glossary keys flagged in this assistant reply. Only meaningful for
   *  assistant turns; ignored for user turns. */
  termsUsed?: readonly string[];
}

/** User vs assistant styling. Assistant replies with flagged glossary
 *  terms get those surface spans wrapped in <GlossaryTerm>. */
export function ChatBubble({ turn, termsUsed }: Props) {
  const config = useProgramConfig();
  const { lang } = useTranslation();
  const isUser = turn.role === 'user';

  const content =
    !isUser && termsUsed && termsUsed.length > 0 ? (
      <>
        {segmentReply(turn.content, termsUsed, config, lang).map((seg, i) =>
          seg.termKey ? (
            <GlossaryTerm key={`g-${i}-${seg.termKey}`} termKey={seg.termKey}>
              {seg.text}
            </GlossaryTerm>
          ) : (
            <span key={`t-${i}`}>{seg.text}</span>
          ),
        )}
      </>
    ) : (
      turn.content
    );

  return (
    <div
      className={
        isUser ? 'cf-bubble cf-bubble--user' : 'cf-bubble cf-bubble--assistant'
      }
    >
      <div className="cf-bubble__role cf-visually-hidden">
        {isUser ? 'You said' : 'CivicForce said'}:
      </div>
      <div className="cf-bubble__text">{content}</div>
    </div>
  );
}
